module.exports = __webpack_public_path__ + "img/steps6-1.7a7970fe.png";